var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "osa-footer" }, [
    _c(
      "span",
      {
        staticClass: "subtitle-2 multi-container",
        attrs: { "subtitle-2": "", "font-weight-medium": "" }
      },
      [
        _c("div", { staticClass: "container-top" }, [
          _c("div", { staticClass: "container-version" }, [
            _c("span", [
              _vm._v(
                "\n          Werbas KSR GmbH Kundenportal Version " +
                  _vm._s(_vm.version.CA) +
                  " | " +
                  _vm._s(_vm.version.CCS) +
                  "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "connection-status" },
            [
              _c("span", [
                _vm._v(
                  " Dienst-Verbindung: " + _vm._s(_vm.connectionStatus) + " "
                )
              ]),
              _vm._v(" "),
              _vm.load
                ? _c("v-progress-circular", {
                    attrs: { size: "20", indeterminate: "" }
                  })
                : _c("v-icon", { class: _vm.iconClass }, [
                    _vm._v(_vm._s(_vm.iconType))
                  ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("hr"),
        _vm._v(" "),
        _c("v-container", { staticClass: "container-address" }, [
          _c("a", { attrs: { href: "https://www.werbas-ksr.com/" } }, [
            _vm._v("Werbas KSR GmbH")
          ]),
          _vm._v(" "),
          _c(
            "span",
            { staticStyle: { "padding-left": "3px", "padding-right": "3px" } },
            [
              _vm._v(
                "| Max-Eyth-Str. 42 | 71088 Holzgerlingen | +49 (0) 7031-2117-0 |"
              )
            ]
          ),
          _vm._v(" "),
          _c("a", { attrs: { href: "mailto:info@werbas-ksr.com" } }, [
            _vm._v("info@werbas-ksr.com")
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }